import { useEffect, useState } from 'react';

interface Props {
  delay?: number;
}

function useDebounce<T>(value: T, options?: Props): T {
  const { delay } = options || {};
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebounce;
